import { render, staticRenderFns } from "./DifficultCompleteExchange.vue?vue&type=template&id=bc02b0e6"
import script from "./DifficultCompleteExchange.vue?vue&type=script&lang=js"
export * from "./DifficultCompleteExchange.vue?vue&type=script&lang=js"
import style0 from "./DifficultCompleteExchange.vue?vue&type=style&index=0&id=bc02b0e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports